export default "__VITE_ASSET__CckJR5xY__"